import MegaMenu from '@components/common/MegaMenu'
import SidebarLayout from '@components/common/SidebarLayout'
import {
  ArrowLeft,
  ArrowRightSmall,
  ChevronRight,
  LegacyCross,
} from '@components/icons'
import { useUI } from '@components/ui/context'
import { groupNavItems } from '@lib/helpers/group-nav-items'
import { useRouter } from 'next/router'
import { useState } from 'react'

export default function MenuSidebarView({
  menuItems = [],
  onClose,
}: {
  menuItems?: any
  onClose: () => void
}) {
  const { closeSidebar } = useUI()
  const router = useRouter()
  const groupedMenuItems = groupNavItems(menuItems?.data?.slices)
  const [showMegaMenu, setShowMegaMenu] = useState(false)
  const [megaMenuIndex, setMegaMenuIndex] = useState(-1)
  const hideMegaMenu = () => {
    setMegaMenuIndex(-1)
    setShowMegaMenu(false)
  }
  const setMegaMenuVisibility = (value: boolean) => {
    setShowMegaMenu(value)
  }
  return (
    <SidebarLayout>
      <div className="pb-10 bg-brand-light-grey w-full">
        <nav>
          {!showMegaMenu && (
            <>
              <div
                className="sticky top-0 pl-4 py-4 pr-6 flex items-center bg-brand-light-grey w-full z-10"
                style={{ minHeight: 56 }}
              >
                <button
                  onClick={onClose}
                  aria-label="Close"
                  className="ml-auto hover:opacity-75 focus:outline-none"
                >
                  <LegacyCross />
                </button>
              </div>
              <ul className="space-y-4 px-5 py-6">
                {groupedMenuItems.map((nav, index) => {
                  const hasSubMenu = nav.type === 'MegaNav'
                  const openMegaMenu = () => {
                    if (hasSubMenu) {
                      setMegaMenuIndex(index)
                      setShowMegaMenu(true)
                    } else {
                      closeSidebar()
                      router.push(nav.link)
                    }
                  }
                  return (
                    <li
                      className="body text-ui-dark-grey flex justify-between"
                      key={nav.label}
                      onClick={openMegaMenu}
                    >
                      <div>{nav.label}</div>
                      {hasSubMenu && (
                        <div className="mt-1">
                          <ChevronRight />
                        </div>
                      )}
                    </li>
                  )
                })}
              </ul>
            </>
          )}
          {showMegaMenu && (
            <div>
              <div
                className="sticky top-0 flex items-center px-4 py-4 bg-white z-10"
                style={{ minHeight: 56 }}
              >
                <button onClick={hideMegaMenu} aria-label="Go back">
                  <ArrowLeft />
                </button>
                <div className="mx-auto body-3-bold text-ui-dark-grey uppercase">
                  {groupedMenuItems[megaMenuIndex]?.label}
                </div>
                <button
                  onClick={onClose}
                  aria-label="Close"
                  className="hover:opacity-75 focus:outline-none"
                >
                  <LegacyCross />
                </button>
              </div>
              <button
                className="body-2-bold text-dark-grey pt-6 px-4 w-full text-left flex flex-row items-center gap-2"
                onClick={() => {
                  const href =
                    groupedMenuItems[megaMenuIndex]?.items?.[0]?.link ||
                    groupedMenuItems[megaMenuIndex]?.link
                  if (href) {
                    closeSidebar()
                    router.push(href)
                  }
                }}
              >
                <span>
                  {groupedMenuItems[megaMenuIndex]?.items?.[0]?.title ||
                    groupedMenuItems[megaMenuIndex]?.label}
                </span>
                <ArrowRightSmall />
              </button>
              <MegaMenu
                handleMegaMenuVisibility={setMegaMenuVisibility}
                menuItems={groupedMenuItems[megaMenuIndex]?.items}
              />
            </div>
          )}
        </nav>
      </div>
    </SidebarLayout>
  )
}

MenuSidebarView
